/**
 * Image Zoom/Lightbox for Comparison Article Images
 * Adds magnifying glass overlay and click-to-zoom functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Target images in desktop-only and combined-image-container
  const targetContainers = document.querySelectorAll(
    '.comparison-article-container .desktop-only, .comparison-article-container .combined-image-container'
  );
  
  targetContainers.forEach(container => {
    const images = container.querySelectorAll('img');
    images.forEach(img => {
      makeImageZoomable(img);
    });
  });
  
  function makeImageZoomable(img) {
    // Skip if already processed or in slider
    if (img.closest('.customer-reviews-slider') || img.dataset.zoomable) return;
    
    img.dataset.zoomable = 'true';
    
    // Wrap image in a container
    const wrapper = document.createElement('div');
    wrapper.className = 'image-zoom-wrapper';
    img.parentNode.insertBefore(wrapper, img);
    wrapper.appendChild(img);
    
    // Create overlay with magnifying glass icon
    const overlay = document.createElement('div');
    overlay.className = 'image-zoom-overlay';
    const isMobile = window.innerWidth <= 749;
    const zoomText = isMobile ? 'Tap for larger view' : 'Click to enlarge';
    overlay.innerHTML = `
      <svg class="image-zoom-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" fill="none"/>
        <path d="M16 16L21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M11 8V14M8 11H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span class="image-zoom-text">${zoomText}</span>
    `;
    wrapper.appendChild(overlay);
    
    // Make wrapper clickable
    wrapper.style.cursor = 'pointer';
    wrapper.addEventListener('click', () => openLightbox(img));
  }
  
  function openLightbox(img) {
    const isMobile = window.innerWidth <= 749;
    const hintHtml = isMobile ? '<div class="image-zoom-hint">Scroll to view • Pinch to zoom</div>' : '';
    
    // Create lightbox modal
    const lightbox = document.createElement('div');
    lightbox.className = 'image-lightbox';
    lightbox.innerHTML = `
      <div class="image-lightbox-backdrop"></div>
      <div class="image-lightbox-content">
        <button class="image-lightbox-close" aria-label="Close">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        ${hintHtml}
        <img src="${img.src}" alt="${img.alt || 'Enlarged image'}" />
      </div>
    `;
    
    document.body.appendChild(lightbox);
    
    // Prevent body scroll on desktop only
    if (!isMobile) {
      document.body.style.overflow = 'hidden';
    }
    
    // Trigger animation
    requestAnimationFrame(() => {
      lightbox.classList.add('active');
    });
    
    // Auto-hide hint on mobile after 3 seconds
    if (isMobile) {
      const hint = lightbox.querySelector('.image-zoom-hint');
      if (hint) {
        setTimeout(() => {
          hint.style.opacity = '0';
          setTimeout(() => hint.remove(), 300);
        }, 3000);
      }
    }
    
    // Close handlers
    const closeBtn = lightbox.querySelector('.image-lightbox-close');
    const backdrop = lightbox.querySelector('.image-lightbox-backdrop');
    
    function closeLightbox() {
      lightbox.classList.remove('active');
      
      // Restore body scroll
      if (!isMobile) {
        document.body.style.overflow = '';
      }
      
      // Wait for animation to complete before removing
      setTimeout(() => {
        lightbox.remove();
      }, 300);
    }
    
    closeBtn.addEventListener('click', closeLightbox);
    
    // Only close on backdrop click for desktop
    if (!isMobile) {
      backdrop.addEventListener('click', closeLightbox);
    }
    
    // ESC key to close
    function handleEscape(e) {
      if (e.key === 'Escape') {
        closeLightbox();
        document.removeEventListener('keydown', handleEscape);
      }
    }
    document.addEventListener('keydown', handleEscape);
  }
});

